import { render, staticRenderFns } from "./IPlicensing.vue?vue&type=template&id=83039a58&scoped=true"
import script from "./IPlicensing.vue?vue&type=script&lang=js"
export * from "./IPlicensing.vue?vue&type=script&lang=js"
import style0 from "./IPlicensing.vue?vue&type=style&index=0&id=83039a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83039a58",
  null
  
)

export default component.exports